import { render, staticRenderFns } from "./AppLinks.vue?vue&type=template&id=b6a70a62"
import script from "./AppLinks.vue?vue&type=script&lang=js"
export * from "./AppLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports